(() => {

  /* =========================================================
     SACH PRODUCT PDP
     CLEAN MASTER JAVASCRIPT
     ========================================================= */


  function init(root) {

    if (root.dataset.sachInitialized === 'true') return;

    root.dataset.sachInitialized = 'true';


    /* =======================================================
       ELEMENTS
       ======================================================= */

    const jsonEl =
      root.querySelector('[data-sach-product-json]');

    const variantSelect =
      root.querySelector('[data-sach-variant-select]');

    const addButton =
      root.querySelector('[data-sach-add]');

    const addLabel =
      root.querySelector('[data-sach-add-label]');

    const addPrice =
      root.querySelector('[data-sach-price]');

    const mainImage =
      root.querySelector('[data-sach-main-image]');

    const planInput =
      root.querySelector('[data-sach-selling-plan-input]');

    const planSelect =
      root.querySelector('[data-sach-selling-plan-select]');

    const subPanel =
      root.querySelector('[data-sach-sub-panel]');

    const subPrice =
      root.querySelector('[data-sach-sub-price]');

    const oncePrice =
      root.querySelector('[data-sach-once-price]');

    const listPrice =
      root.querySelector('[data-sach-list-price]');

    const discountLabel =
      root.querySelector('[data-sach-discount-label]');

    const saveBenefit =
      root.querySelector('[data-sach-save-benefit]');


    const purchaseModes = [
      ...root.querySelectorAll(
        '[data-sach-purchase-mode]'
      )
    ];


    const optionInputs = [
      ...root.querySelectorAll(
        '[data-sach-option-input]'
      )
    ];


    const thumbs = [
      ...root.querySelectorAll(
        '[data-sach-thumb]'
      )
    ];


    if (!jsonEl || !variantSelect) return;



    /* =======================================================
       PRODUCT JSON
       ======================================================= */

    let data;


    try {

      data =
        JSON.parse(
          jsonEl.textContent
        );

    } catch (error) {

      console.error(
        'SACH PDP JSON error',
        error
      );

      return;
    }



    /* =======================================================
       SMALL MOTION STYLES
       Keeps pack changes from feeling abrupt.
       ======================================================= */

    if (
      !document.getElementById(
        'sach-pdp-motion-styles'
      )
    ) {

      const style =
        document.createElement('style');

      style.id =
        'sach-pdp-motion-styles';


      style.textContent = `

        .sach-pdp__pack-card {
          transition:
            background-color 180ms ease,
            border-color 180ms ease,
            color 180ms ease,
            transform 120ms ease !important;
        }

        .sach-pdp__pack-card:hover {
          transform: translateY(-1px);
        }

        .sach-pdp__pack-card:active {
          transform: scale(.985);
        }

        .sach-pdp__purchase-panel {
          transition:
            background-color 180ms ease !important;
        }

        .sach-pdp [data-sach-price],
        .sach-pdp [data-sach-sub-price],
        .sach-pdp [data-sach-once-price],
        .sach-pdp [data-sach-list-price],
        .sach-pdp [data-sach-pack-each] {
          transition:
            opacity 120ms ease,
            transform 120ms ease;
        }

        .sach-pdp .sach-price-updating {
          opacity: .35;
          transform: translateY(1px);
        }

      `;


      document.head.appendChild(
        style
      );

    }



    /* =======================================================
       HELPERS
       ======================================================= */

    function money(cents) {

      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney ===
          'function'
      ) {

        return window.Shopify.formatMoney(
          Number(cents),
          data.money_format
        );

      }


      return (
        '$' +
        (
          Number(cents) / 100
        ).toFixed(2)
      );

    }



    function updateText(
      element,
      value
    ) {

      if (!element) return;


      const next =
        String(value ?? '');


      if (
        element.textContent.trim() ===
        next.trim()
      ) {
        return;
      }


      element.classList.add(
        'sach-price-updating'
      );


      window.requestAnimationFrame(
        () => {

          element.textContent =
            next;


          window.requestAnimationFrame(
            () => {

              element.classList.remove(
                'sach-price-updating'
              );

            }
          );

        }
      );

    }



    function packCount(value) {

      const match =
        String(value || '')
          .match(/\d+/);


      return match
        ? Math.max(
            1,
            parseInt(
              match[0],
              10
            )
          )
        : 1;

    }



    function selectedOptions() {

      const groups = [
        ...root.querySelectorAll(
          'fieldset[data-option-position]'
        )
      ];


      if (!groups.length) {
        return [];
      }


      return groups
        .sort(
          (a, b) =>
            Number(
              a.dataset.optionPosition
            ) -
            Number(
              b.dataset.optionPosition
            )
        )
        .map(group => {

          return (
            group.querySelector(
              '[data-sach-option-input]:checked'
            )?.value || ''
          );

        });

    }



    function currentVariant() {

      const options =
        selectedOptions();


      if (!options.length) {

        return (
          data.variants.find(
            variant =>
              String(variant.id) ===
              String(
                variantSelect.value
              )
          ) ||
          data.variants[0] ||
          null
        );

      }


      return (
        data.variants.find(
          variant =>
            JSON.stringify(
              variant.options
            ) ===
            JSON.stringify(
              options
            )
        ) || null
      );

    }



    function variantForPack(
      packValue,
      position
    ) {

      const options =
        selectedOptions();


      if (!options.length) {
        return null;
      }


      options[position - 1] =
        packValue;


      return (
        data.variants.find(
          variant =>
            JSON.stringify(
              variant.options
            ) ===
            JSON.stringify(
              options
            )
        ) || null
      );

    }



    function selectedPlan(
      variant
    ) {

      if (
        !variant ||
        !variant.selling_plans ||
        !variant.selling_plans.length
      ) {

        return null;
      }


      const selectedId =
        planSelect?.value;


      return (
        variant.selling_plans.find(
          plan =>
            String(plan.id) ===
            String(selectedId)
        ) ||
        variant.selling_plans[0]
      );

    }



    function planDiscount(
      plan,
      variant
    ) {

      if (!plan) return 0;


      const regularPrice =
        Number(
          plan.compare_at_price ||
          variant.price ||
          0
        );


      const subscriptionPrice =
        Number(
          plan.price ||
          regularPrice
        );


      if (
        !regularPrice ||
        subscriptionPrice >= regularPrice
      ) {

        return 0;
      }


      return Math.round(
        (
          (
            regularPrice -
            subscriptionPrice
          ) /
          regularPrice
        ) *
        100
      );

    }



    /*
     * Cleans Recharge plan names for the customer.
     *
     * Example:
     * "1 month subscription with 5% discount"
     * becomes:
     * "1 month"
     */

    function cleanPlanName(name) {

      const raw =
        String(name || '').trim();


      const match =
        raw.match(
          /(\d+)\s*(day|days|week|weeks|month|months|year|years)/i
        );


      if (!match) {
        return raw;
      }


      const amount =
        Number(match[1]);


      let unit =
        match[2]
          .toLowerCase()
          .replace(/s$/, '');


      if (amount === 1) {

        return `1 ${unit}`;

      }


      return `${amount} ${unit}s`;

    }



    /* =======================================================
       PACK PRICE DISPLAY
       ======================================================= */

    function refreshPackPrices() {

      root
        .querySelectorAll(
          '[data-sach-option-card]'
        )
        .forEach(card => {

          const input =
            card.querySelector(
              '[data-sach-option-input]'
            );

          const each =
            card.querySelector(
              '[data-sach-pack-each]'
            );


          if (
            !input ||
            !each
          ) {
            return;
          }


          const variant =
            variantForPack(
              input.value,
              Number(
                input.dataset.optionPosition
              )
            );


          if (!variant) return;


          const count =
            packCount(
              input.value
            );


          const eachPrice =
            Math.round(
              Number(
                variant.price
              ) /
              count
            );


          updateText(
            each,
            `${money(eachPrice)} each`
          );

        });

    }



    /* =======================================================
       SUBSCRIPTION PLAN DROPDOWN
       ======================================================= */

    function refreshSellingPlans(
      variant
    ) {

      if (
        !planSelect ||
        !subPanel
      ) {
        return;
      }


      const plans =
        variant?.selling_plans || [];


      /*
       * Remember which cadence the customer had selected.
       */

      const previousId =
        planSelect.value;


      const previousIndex =
        planSelect.selectedIndex >= 0
          ? planSelect.selectedIndex
          : 0;


      planSelect.innerHTML =
        '';


      plans.forEach(plan => {

        const option =
          document.createElement(
            'option'
          );


        option.value =
          plan.id;


        option.textContent =
          cleanPlanName(
            plan.name
          );


        planSelect.appendChild(
          option
        );

      });



      subPanel.hidden =
        plans.length === 0;


      if (!plans.length) {
        return;
      }



      const samePlan =
        plans.find(
          plan =>
            String(plan.id) ===
            String(previousId)
        );


      if (samePlan) {

        planSelect.value =
          samePlan.id;

      } else {

        const safeIndex =
          Math.min(
            previousIndex,
            plans.length - 1
          );


        planSelect.selectedIndex =
          Math.max(
            0,
            safeIndex
          );

      }

    }



    /* =======================================================
       PURCHASE MODE
       ======================================================= */

    let mode =
      root.querySelector(
        '[data-sach-purchase-mode]:checked'
      )?.value ||
      'once';



    function setMode(nextMode) {

      const variant =
        currentVariant();


      const hasPlans =
        !!(
          variant &&
          variant.selling_plans &&
          variant.selling_plans.length
        );


      mode =
        nextMode === 'subscription' &&
        hasPlans
          ? 'subscription'
          : 'once';


      purchaseModes.forEach(
        input => {

          input.checked =
            input.value === mode;

        }
      );


      refreshPurchaseUI();

    }



    /* =======================================================
       PURCHASE BOX + CTA PRICE
       ======================================================= */

    function refreshPurchaseUI() {

      const variant =
        currentVariant();


      if (!variant) return;


      const plan =
        selectedPlan(
          variant
        );


      const hasSubscription =
        !!plan;


      if (
        mode === 'subscription' &&
        !hasSubscription
      ) {

        mode =
          'once';

      }


      const isSubscription =
        mode === 'subscription' &&
        hasSubscription;



      /* Selected radio */

      purchaseModes.forEach(
        input => {

          input.checked =
            input.value === mode;

        }
      );



      /* Selected background */

      root
        .querySelectorAll(
          '.sach-pdp__purchase-panel'
        )
        .forEach(panel => {

          const input =
            panel.querySelector(
              '[data-sach-purchase-mode]'
            );


          panel.classList.toggle(
            'is-selected',
            !!input?.checked
          );

        });



      /* Subscription visibility */

      if (subPanel) {

        subPanel.hidden =
          !(
            variant.selling_plans &&
            variant.selling_plans.length
          );

      }



      /* One-time price */

      updateText(
        oncePrice,
        money(
          variant.price
        )
      );



      /* Subscription values */

      if (plan) {

        const discount =
          planDiscount(
            plan,
            variant
          );


        updateText(
          subPrice,
          money(
            plan.price
          )
        );


        const comparePrice =
          Number(
            plan.compare_at_price ||
            variant.price
          );


        updateText(
          listPrice,
          comparePrice >
          Number(plan.price)
            ? money(comparePrice)
            : ''
        );


        updateText(
          discountLabel,
          discount > 0
            ? `${discount}%`
            : ''
        );


        updateText(
          saveBenefit,
          discount > 0
            ? `✓ Save ${discount}% on every delivery`
            : '✓ Save on every recurring order'
        );

      } else {

        updateText(
          subPrice,
          ''
        );

        updateText(
          listPrice,
          ''
        );

        updateText(
          discountLabel,
          ''
        );

      }



      /*
       * This is the actual Shopify field that determines
       * subscription vs one-time when Add to Cart is clicked.
       */

      if (planInput) {

        planInput.value =
          isSubscription &&
          plan
            ? plan.id
            : '';

      }



      /*
       * IMPORTANT:
       * Update CTA price immediately.
       */

      updateText(
        addPrice,
        isSubscription &&
        plan
          ? money(plan.price)
          : money(variant.price)
      );


      updateUrl(
        variant,
        isSubscription
          ? plan
          : null
      );

    }



    /* =======================================================
       URL
       ======================================================= */

    function updateUrl(
      variant,
      plan
    ) {

      if (
        !history.replaceState ||
        !variant
      ) {
        return;
      }


      const url =
        new URL(
          window.location.href
        );


      url.searchParams.set(
        'variant',
        variant.id
      );


      if (plan) {

        url.searchParams.set(
          'selling_plan',
          plan.id
        );

      } else {

        url.searchParams.delete(
          'selling_plan'
        );

      }


      history.replaceState(
        {},
        '',
        url.toString()
      );

    }



    /* =======================================================
       VARIANT / PACK CHANGE
       ======================================================= */

    function refreshVariant() {

      const variant =
        currentVariant();


      if (!variant) {

        if (addButton) {
          addButton.disabled =
            true;
        }


        if (addLabel) {

          addLabel.textContent =
            'Unavailable';

        }


        return;
      }



      /*
       * Update selected pack appearance immediately.
       */

      root
        .querySelectorAll(
          '[data-sach-option-card]'
        )
        .forEach(card => {

          const input =
            card.querySelector(
              '[data-sach-option-input]'
            );


          card.classList.toggle(
            'is-selected',
            !!input?.checked
          );

        });



      /*
       * Update Shopify variant.
       */

      const variantChanged =
        String(
          variantSelect.value
        ) !==
        String(
          variant.id
        );


      variantSelect.value =
        variant.id;



      if (variantChanged) {

        variantSelect.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );

      }



      /* Availability */

      if (addButton) {

        addButton.disabled =
          !variant.available;

      }


      if (addLabel) {

        addLabel.textContent =
          variant.available
            ? 'Add to cart'
            : 'Sold out';

      }



      /*
       * Preserve whether customer picked
       * Subscribe or One-time.
       */

      const previousMode =
        mode;



      /*
       * Refresh all prices/plans for
       * the newly selected pack.
       */

      refreshPackPrices();

      refreshSellingPlans(
        variant
      );



      if (
        previousMode === 'subscription' &&
        variant.selling_plans &&
        variant.selling_plans.length
      ) {

        mode =
          'subscription';

      } else if (
        previousMode === 'once'
      ) {

        mode =
          'once';

      } else if (
        variant.selling_plans &&
        variant.selling_plans.length
      ) {

        mode =
          'subscription';

      } else {

        mode =
          'once';

      }



      /*
       * One single UI refresh after
       * the new variant is fully selected.
       */

      refreshPurchaseUI();

    }



    /* =======================================================
       PACK EVENTS
       ======================================================= */

    optionInputs.forEach(
      input => {

        input.addEventListener(
          'change',
          refreshVariant
        );

      }
    );



    /* =======================================================
       SUBSCRIBE / ONE-TIME EVENTS
       ======================================================= */

    purchaseModes.forEach(
      input => {

        input.addEventListener(
          'change',
          () => {

            if (input.checked) {

              setMode(
                input.value
              );

            }

          }
        );

      }
    );



    /* =======================================================
       DELIVERY FREQUENCY
       ======================================================= */

    if (planSelect) {

      planSelect.addEventListener(
        'change',
        refreshPurchaseUI
      );

    }



    /* =======================================================
       GALLERY
       ======================================================= */

    thumbs.forEach(
      thumb => {

        thumb.addEventListener(
          'click',
          () => {

            if (mainImage) {

              mainImage.src =
                thumb.dataset.imageSrc;


              mainImage.removeAttribute(
                'srcset'
              );

            }



            thumbs.forEach(
              item => {

                const active =
                  item === thumb;


                item.classList.toggle(
                  'is-active',
                  active
                );


                item.setAttribute(
                  'aria-pressed',
                  active
                    ? 'true'
                    : 'false'
                );

              }
            );

          }
        );

      }
    );



    /* =======================================================
       REMOVE OLD RECHARGE AUTO-WIDGET
       We are using Shopify selling plans directly now.
       ======================================================= */

    function removeRechargeDuplicate() {

      root
        .querySelectorAll(
          '.rc-container, .rc-widget'
        )
        .forEach(widget => {

          if (
            !widget.closest(
              '.sach-pdp__purchase'
            )
          ) {

            widget.remove();

          }

        });

    }


    removeRechargeDuplicate();


    const rechargeObserver =
      new MutationObserver(
        removeRechargeDuplicate
      );


    rechargeObserver.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );



    /* =======================================================
       INITIAL STATE
       ======================================================= */

    const initialVariant =
      currentVariant();


    /*
     * If subscriptions exist and nothing
     * has explicitly selected one-time,
     * default to Subscribe & Save.
     */

    if (
      initialVariant &&
      initialVariant.selling_plans &&
      initialVariant.selling_plans.length
    ) {

      const checkedMode =
        root.querySelector(
          '[data-sach-purchase-mode]:checked'
        );


      mode =
        checkedMode
          ? checkedMode.value
          : 'subscription';

    } else {

      mode =
        'once';

    }


    refreshVariant();

  }



  /* =========================================================
     INITIALIZE ALL PDP SECTIONS
     ========================================================= */

  function initAll() {

    document
      .querySelectorAll(
        '[data-sach-pdp]'
      )
      .forEach(init);

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }



  document.addEventListener(
    'shopify:section:load',
    initAll
  );

})();